import { put, takeLeading } from 'redux-saga/effects';

import financeApi from 'api/finance';
import { apiErrorHandler } from 'utils';

import * as Actions from './actions';
import * as ActionTypes from './actionTypes';

function* getFinances({ payload }) {
  try {
    const data = yield financeApi.getFinances(payload);

    yield put(Actions.getFinancesSuccess(data.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.getFinancesFailed());
  }
}

function* getFinanceOverview({ payload }) {
  try {
    const data = yield financeApi.getFinanceOverview(payload);

    yield put(Actions.getFinanceOverviewSuccess(data.payload));
  } catch (error) {
    apiErrorHandler(error);

    yield put(Actions.getFinanceOverviewFailed());
  }
}

export default function* finance() {
  yield takeLeading(ActionTypes.GET_FINANCES, getFinances);
  yield takeLeading(ActionTypes.GET_FINANCE_OVERVIEW, getFinanceOverview);
}
